<div class="border-card border-0 px-4 py-1">
    <div class="row mt-4">
      <div v-for="card in status_cards" :key="card.title" class="col-md-4">
        <div class="card card-bg shadow rounded-lg border-0 h-100">
          <div class="card-body">
            <h5 class="card-title d-flex text-white justify-content-between align-items-center">
              {{ card.title }}
              <div class="align-self-center rounded-circle">
                <i :class="[card.icon, card.color_class]"></i>
              </div>
            </h5>
            <div class="d-flex justify-content-between align-items-center px-md-1">
              <span class="fs-4" :class="card.color_class">{{ get_count(card.type) }}</span>
              <a href="#" class="text-decoration-none text-x" :class="card.color_class" @click.prevent="selected_status = card.type"><i class="bi bi-eye-fill"></i> View</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="card rounded-lg p-0 mt-5 shadow border-0" v-if="selected_status || selected_status === ''">
      <div class="card-header bg-white border-0 d-flex justify-content-between align-application_datas-center pb-0 rounded-lg">
        <p class="p-2 mb-0">
        {{ selected_status ? status_cards.find(card => card.type === selected_status)?.title : 'Invoice Status' }}
        </p>
      </div>
      <div class="card-body">
        <GlobalTable 
          v-if="selected_status === ''"
          :headers="['Application No', 'Founder Name', 'Trust Name', 'Date Started', 'Date Modified', 'Status']" 
          :data="trust_application_data" 
          table_id="trust_payments">
          <template #actions="{ row }">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="redirect_to_manage_compliance_requirements">View</button>
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">Log</button>
          </template>
        </GlobalTable>
      
        <GlobalTable 
          v-if="selected_status === 'pending payment'"
          :headers="['Application No', 'Founder Name', 'Trust Name', 'Date Started', 'Date Modified', 'Status']" 
          :data="trust_application_data.filter(app => app.status === 'pending payment')" 
          table_id="pending_payment">
          <template #actions="{ row }">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="redirect_to_manage_compliance_requirements">View</button>
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">Log</button>
          </template>
        </GlobalTable>
      
      
        <GlobalTable 
          v-if="selected_status === 'partially paid'"
          :headers="['Application No', 'Founder Name', 'Trust Name', 'Date Started', 'Date Modified', 'Status']" 
          :data="trust_application_data.filter(app => app.status === 'partially paid')" 
          table_id="partially_paid">
          <template #actions="{ row }">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">View</button>
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">Log</button>
          </template>
        </GlobalTable>

        <GlobalTable 
          v-if="selected_status === 'paid'"
          :headers="['Application No', 'Founder Name', 'Trust Name', 'Date Started', 'Date Modified', 'Status']" 
          :data="trust_application_data.filter(app => app.status === 'paid')" 
          table_id="fully_paid">
          <template #actions="{ row }">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">View</button>
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">Log</button>
          </template>
        </GlobalTable>

      </div>
    </div>
    
    <footer>
      <AICampusFooter/>
    </footer>
  </div>